<template>
    <div>
        <b-sidebar
            v-model="open"
            title="Detalhes do Aluno"
            backdrop-variant="dark"
            width="390px"
            backdrop
            shadow
        >
            <div class="px-3 py-2" v-if="student">
                <dl>
                    <dd>
                        <b-button variant="outline-primary" size="sm" @click="loginStudent" :disabled="loadingLogin">
                            <i class="fas fa-sign-in-alt mr-1"></i>
                            entrar nessa conta
                        </b-button>
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Nome
                    </dt>
                    <dd>
                        {{ student.name }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Email
                    </dt>
                    <dd>
                        {{ student.email }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Telefone
                    </dt>
                    <dd>
                        {{ student.phone }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Conta Criada
                    </dt>
                    <dd>
                        {{ student.created_at | moment('from', 'now') }}
                    </dd>
                </dl>
                <dl>
                    <dt>
                        Última Modificação
                    </dt>
                    <dd>
                        {{ student.updated_at | moment('from', 'now') }}
                    </dd>
                </dl>
            </div>
        </b-sidebar>
    </div>
</template>

<script>

export default {
    props: [],
    data() {
        return {
            open: false,
            student: null,
            id: null,
            loadingLogin: false,
            loadingPremium: false,
        }
    },
    created() {

        this.$root.$on('studentsShowDetail', (student) => {
            this.student = student
            this.id = student.id
            this.open = true
        })

    },
    methods: {

        loginStudent() {
            this.loadingLogin = true;
            axios.post('/admin/students/' + this.id + '/login')
                .then((result) => {
                    const response = result.data.data;

                    if (response.login) {
                        window.open('/student/dashboard', '_blank');
                    }

                })
                .finally(() => this.loadingLogin = false)
        },

    }
}
</script>

<style scoped>

</style>
